export const countries = [
  "أفغانستان",
  "ألبانيا",
  "الجزائر",
  "أندورا",
  "أنغولا",
  "أنتيغوا وباربودا",
  "الأرجنتين",
  "أرمينيا",
  "أستراليا",
  "النمسا",
  "أذربيجان",
  "الباهاماس",
  "البحرين",
  "بنغلاديش",
  "باربادوس",
  "بيلاروس",
  "بلجيكا",
  "بليز",
  "بنين",
  "بوتان",
  "بوليفيا",
  "البوسنة والهرسك",
  "بوتسوانا",
  "البرازيل",
  "بروناي",
  "بلغاريا",
  "بوركينا فاسو",
  "بوروندي",
  "ساحل العاج",
  "كمبوديا",
  "الكاميرون",
  "كندا",
  "جمهورية أفريقيا الوسطى",
  "تشاد",
  "تشيلي",
  "الصين",
  "كولومبيا",
  "جزر القمر",
  "الكونغو - برازافيل",
  "الكونغو - كينشاسا",
  "كوستاريكا",
  "كرواتيا",
  "كوبا",
  "قبرص",
  "التشيك",
  "الدنمارك",
  "جيبوتي",
  "دومينيكا",
  "جمهورية الدومينيكان",
  "تيمور الشرقية",
  "الإكوادور",
  "مصر",
  "السلفادور",
  "غينيا الاستوائية",
  "إريتريا",
  "إستونيا",
  "إسواتيني",
  "إثيوبيا",
  "فيجي",
  "فنلندا",
  "فرنسا",
  "الغابون",
  "غامبيا",
  "جورجيا",
  "ألمانيا",
  "غانا",
  "اليونان",
  "غرينادا",
  "غواتيمالا",
  "غينيا",
  "غينيا بيساو",
  "غيانا",
  "هايتي",
  "هندوراس",
  "هنغاريا",
  "آيسلندا",
  "الهند",
  "إندونيسيا",
  "إيران",
  "العراق",
  "أيرلندا",
  "إسرائيل",
  "إيطاليا",
  "جامايكا",
  "اليابان",
  "الأردن",
  "كازاخستان",
  "كينيا",
  "كيريباتي",
  "كوريا الشمالية",
  "كوريا الجنوبية",
  "الكويت",
  "قرغيزستان",
  "لاوس",
  "لاتفيا",
  "لبنان",
  "ليسوتو",
  "ليبيريا",
  "ليبيا",
  "ليختنشتاين",
  "ليتوانيا",
  "لوكسمبورغ",
  "مدغشقر",
  "مالاوي",
  "ماليزيا",
  "جزر المالديف",
  "مالي",
  "مالطا",
  "جزر مارشال",
  "موريتانيا",
  "موريشيوس",
  "المكسيك",
  "ميكرونيسيا",
  "مولدوفا",
  "موناكو",
  "منغوليا",
  "الجبل الأسود",
  "المغرب",
  "موزمبيق",
  "ميانمار",
  "ناميبيا",
  "ناورو",
  "نيبال",
  "هولندا",
  "نيوزيلندا",
  "نيكاراغوا",
  "النيجر",
  "نيجيريا",
  "مقدونيا الشمالية",
  "النرويج",
  "عمان",
  "باكستان",
  "بالاو",
  "بنما",
  "بابوا غينيا الجديدة",
  "باراغواي",
  "بيرو",
  "الفلبين",
  "بولندا",
  "البرتغال",
  "قطر",
  "رومانيا",
  "روسيا",
  "رواندا",
  "سانت كيتس ونيفيس",
  "سانت لوسيا",
  "سانت فنسنت والغرينادين",
  "ساموا",
  "سان مارينو",
  "ساو تومي وبرينسيب",
  "السعودية",
  "السنغال",
  "صربيا",
  "سيشل",
  "سيراليون",
  "سنغافورة",
  "سلوفاكيا",
  "سلوفينيا",
  "جزر سليمان",
  "الصومال",
  "جنوب أفريقيا",
  "جنوب السودان",
  "إسبانيا",
  "سريلانكا",
  "السودان",
  "سورينام",
  "السويد",
  "سويسرا",
  "سوريا",
  "طاجيكستان",
  "تنزانيا",
  "تايلاند",
  "توغو",
  "تونغا",
  "ترينيداد وتوباغو",
  "تونس",
  "تركيا",
  "تركمانستان",
  "توفالو",
  "أوغندا",
  "أوكرانيا",
  "الإمارات العربية المتحدة",
  "المملكة المتحدة",
  "الولايات المتحدة",
  "أوروغواي",
  "أوزبكستان",
  "فانواتو",
  "فنزويلا",
  "فيتنام",
  "اليمن",
  "زامبيا",
  "زيمبابوي",
];
export const nationalities = [
  { male: "سوري", female: "سورية" },
  { male: "فنزويلي", female: "فنزويلية" },
  { male: "مصري", female: "مصرية" },
  { male: "سعودي", female: "سعودية" },
  { male: "أردني", female: "أردنية" },
  { male: "ليبي", female: "ليبية" },
  { male: "لبناني", female: "لبنانية" },
  { male: "تونسي", female: "تونسية" },
  { male: "عراقي", female: "عراقية" },
  { male: "كويتي", female: "كويتية" },
  { male: "بوسني", female: "بوسنية" },
  { male: "إماراتي", female: "إماراتية" },
  { male: "عماني", female: "عمانية" },
  { male: "مغربي", female: "مغربية" },
  { male: "جزائري", female: "جزائرية" },
  { male: "فلسطيني", female: "فلسطينية" },
  { male: "سوداني", female: "سودانية" },
  { male: "قطري", female: "قطرية" },
  { male: "موريتاني", female: "موريتانية" },
  { male: "جيبوتي", female: "جيبوتية" },
  { male: "بحريني", female: "بحرينية" },
  { male: "مغربي", female: "مغربية" },
  { male: "صومالي", female: "صومالية" },
  { male: "تشادي", female: "تشادية" },
  { male: "جزر القمر", female: "جزيرة القمر" },
  { male: "إريتري", female: "إريترية" },
  { male: "فلسطيني", female: "فلسطينية" },
  { male: "أفغاني", female: "أفغانية" },
  { male: "باكستاني", female: "باكستانية" },
  { male: "هندي", female: "هندية" },
  { male: "بنغلاديشي", female: "بنغلاديشية" },
  { male: "نيوزيلندي", female: "نيوزيلندية" },
  { male: "أسترالي", female: "أسترالية" },
  { male: "كندي", female: "كندية" },
  { male: "أمريكي", female: "أمريكية" },
  { male: "بريطاني", female: "بريطانية" },
  { male: "أيرلندي", female: "أيرلندية" },
  { male: "فرنسي", female: "فرنسية" },
  { male: "إسباني", female: "إسبانية" },
  { male: "إيطالي", female: "إيطالية" },
  { male: "ألماني", female: "ألمانية" },
  { male: "هولندي", female: "هولندية" },
  { male: "بلجيكي", female: "بلجيكية" },
  { male: "سويسري", female: "سويسرية" },
  { male: "سويدي", female: "سويدية" },
  { male: "دنماركي", female: "دنماركية" },
  { male: "فنلندي", female: "فنلندية" },
  { male: "نمساوي", female: "نمساوية" },
  { male: "بولندي", female: "بولندية" },
  { male: "تركي", female: "تركية" },
  { male: "يوناني", female: "يونانية" },
  { male: "روسي", female: "روسية" },
  { male: "صيني", female: "صينية" },
  { male: "ياباني", female: "يابانية" },
  { male: "كوري", female: "كورية" },
  { male: "مكسيكي", female: "مكسيكية" },
  { male: "كوبي", female: "كوبية" },
  { male: "فنزويلي", female: "فنزويلية" },
  { male: "تشيلاني", female: "تشيلية" },
  { male: "أرجنتيني", female: "أرجنتينية" },
  { male: "بيروفي", female: "بيروفية" },
  { male: "باراغوياني", female: "باراغويانية" },
  { male: "كولومبي", female: "كولومبية" },
  { male: "هندي", female: "هندية" },
  { male: "إيراني", female: "إيرانية" },
  { male: "باكستاني", female: "باكستانية" },
  { male: "بريطاني", female: "بريطانية" },
  { male: "أوروبي", female: "أوروبية" },
  { male: "شامي", female: "شامية" },
  { male: "أمريكي", female: "أمريكية" },
  { male: "إفريقي", female: "إفريقية" }
];
export const beardHijab=[["غير محجبة","حجاب","نقاب"],["بدون لحية","لحية خفيفة","لحية كثيفة"]]

export const religiosity={
  muslim:["زيدي","شيعي","حنفي","شافعي","حنبلي","مالكي","اشعري","اباظي","ماتردي","جهمي","معتزلي","احمدي","اسماعيلي"],
  christian:["كاثوليك","أرثوذكس","بروتستانت"]
}

export const registerationSettings = {
        "genders": [
            "ذكر",
            "أنثى"
        ],
        "beards": [
            "بدون لحية",
            "لحية خفيفة",
            "لحية كثيفة"
        ],
        "hijabs": [
            "غير محجبة",
            "حجاب",
            "نقاب"
        ],
        "social_statuses_male": [
            "عازب",
            "أرمل",
            "مطلق",
            "متزوج"
        ],
        "social_statuses_female": [
            "عازبة",
            "أرملة",
            "مطلقة"
        ],
        "religions": [
            "مسلم",
            "مسيحي"
        ],
        "religiosities_muslim": [
            "زيدي",
            "شيعي",
            "حنفي",
            "شافعي",
            "حنبلي",
            "مالكي",
            "اشعري",
            "اباظي",
            "ماتردي",
            "معتزلي",
            "جهمي",
            "احمدي",
            "اسماعيلي"
        ],
        "religiosities_chrisians": [
            "كاثوليك",
            "أرثوذكس",
            "بروتستانت"
        ],
        "skin_colours": [
            "أبيض",
            "حنطي",
            "أسمر",
            "أسود"
        ],
        "countries_ar": [
            {
                "id": 18,
                "country_ar": "البحرين"
            },
            {
                "id": 104,
                "country_ar": "العراق"
            },
            {
                "id": 111,
                "country_ar": "الأردن"
            },
            {
                "id": 118,
                "country_ar": "الكويت"
            },
            {
                "id": 122,
                "country_ar": "لبنان"
            },
            {
                "id": 167,
                "country_ar": "عمان"
            },
            {
                "id": 170,
                "country_ar": "فلسطين"
            },
            {
                "id": 180,
                "country_ar": "قطر"
            },
            {
                "id": 193,
                "country_ar": "المملكة العربية السعودية"
            },
            {
                "id": 214,
                "country_ar": "سوريا"
            },
            {
                "id": 231,
                "country_ar": "الإمارات العربية المتحدة"
            },
            {
                "id": 244,
                "country_ar": "اليمن"
            },
            {
                "id": 4,
                "country_ar": "الجزائر"
            },
            {
                "id": 60,
                "country_ar": "جيبوتي"
            },
            {
                "id": 64,
                "country_ar": "مصر"
            },
            {
                "id": 125,
                "country_ar": "ليبيا"
            },
            {
                "id": 140,
                "country_ar": "موريتانيا"
            },
            {
                "id": 150,
                "country_ar": "المغرب"
            },
            {
                "id": 202,
                "country_ar": "الصومال"
            },
            {
                "id": 208,
                "country_ar": "السودان"
            },
            {
                "id": 224,
                "country_ar": "تونس"
            },
            {
                "id": 44,
                "country_ar": "تشاد"
            },
            {
                "id": 50,
                "country_ar": "جزر القمر"
            },
            {
                "id": 1,
                "country_ar": "أفغانستان"
            },
            {
                "id": 2,
                "country_ar": "ألبانيا"
            },
            {
                "id": 3,
                "country_ar": "جزر آلاند"
            },
            {
                "id": 5,
                "country_ar": "ساموا-الأمريكي"
            },
            {
                "id": 6,
                "country_ar": "أندورا"
            },
            {
                "id": 7,
                "country_ar": "أنغولا"
            },
            {
                "id": 8,
                "country_ar": "أنغويلا"
            },
            {
                "id": 9,
                "country_ar": "أنتاركتيكا"
            },
            {
                "id": 10,
                "country_ar": "أنتيغوا وبربودا"
            },
            {
                "id": 11,
                "country_ar": "الأرجنتين"
            },
            {
                "id": 12,
                "country_ar": "أرمينيا"
            },
            {
                "id": 13,
                "country_ar": "أروبه"
            },
            {
                "id": 14,
                "country_ar": "أستراليا"
            },
            {
                "id": 15,
                "country_ar": "النمسا"
            },
            {
                "id": 16,
                "country_ar": "أذربيجان"
            },
            {
                "id": 17,
                "country_ar": "الباهاماس"
            },
            {
                "id": 19,
                "country_ar": "بنغلاديش"
            },
            {
                "id": 20,
                "country_ar": "بربادوس"
            },
            {
                "id": 21,
                "country_ar": "روسيا البيضاء"
            },
            {
                "id": 22,
                "country_ar": "بلجيكا"
            },
            {
                "id": 23,
                "country_ar": "بيليز"
            },
            {
                "id": 24,
                "country_ar": "بنين"
            },
            {
                "id": 25,
                "country_ar": "سان بارتيلمي"
            },
            {
                "id": 26,
                "country_ar": "جزر برمودا"
            },
            {
                "id": 27,
                "country_ar": "بوتان"
            },
            {
                "id": 28,
                "country_ar": "بوليفيا"
            },
            {
                "id": 29,
                "country_ar": "البوسنة و الهرسك"
            },
            {
                "id": 30,
                "country_ar": "بوتسوانا"
            },
            {
                "id": 31,
                "country_ar": "جزيرة بوفيه"
            },
            {
                "id": 32,
                "country_ar": "البرازيل"
            },
            {
                "id": 33,
                "country_ar": "إقليم المحيط الهندي البريطاني"
            },
            {
                "id": 35,
                "country_ar": "بلغاريا"
            },
            {
                "id": 36,
                "country_ar": "بوركينا فاسو"
            },
            {
                "id": 37,
                "country_ar": "بوروندي"
            },
            {
                "id": 38,
                "country_ar": "كمبوديا"
            },
            {
                "id": 39,
                "country_ar": "كاميرون"
            },
            {
                "id": 40,
                "country_ar": "كندا"
            },
            {
                "id": 42,
                "country_ar": "جزر كايمان"
            },
            {
                "id": 43,
                "country_ar": "جمهورية أفريقيا الوسطى"
            },
            {
                "id": 45,
                "country_ar": "شيلي"
            },
            {
                "id": 46,
                "country_ar": "الصين"
            },
            {
                "id": 47,
                "country_ar": "جزيرة عيد الميلاد"
            },
            {
                "id": 48,
                "country_ar": "جزر كوكوس"
            },
            {
                "id": 49,
                "country_ar": "كولومبيا"
            },
            {
                "id": 52,
                "country_ar": "جزر كوك"
            },
            {
                "id": 53,
                "country_ar": "كوستاريكا"
            },
            {
                "id": 54,
                "country_ar": "كرواتيا"
            },
            {
                "id": 55,
                "country_ar": "كوبا"
            },
            {
                "id": 56,
                "country_ar": "قبرص"
            },
            {
                "id": 57,
                "country_ar": "كوراساو"
            },
            {
                "id": 58,
                "country_ar": "الجمهورية التشيكية"
            },
            {
                "id": 59,
                "country_ar": "الدانمارك"
            },
            {
                "id": 61,
                "country_ar": "دومينيكا"
            },
            {
                "id": 62,
                "country_ar": "الجمهورية الدومينيكية"
            },
            {
                "id": 63,
                "country_ar": "إكوادور"
            },
            {
                "id": 65,
                "country_ar": "إلسلفادور"
            },
            {
                "id": 66,
                "country_ar": "غينيا الاستوائي"
            },
            {
                "id": 67,
                "country_ar": "إريتريا"
            },
            {
                "id": 68,
                "country_ar": "استونيا"
            },
            {
                "id": 69,
                "country_ar": "أثيوبيا"
            },
            {
                "id": 70,
                "country_ar": "جزر فوكلاند"
            },
            {
                "id": 71,
                "country_ar": "جزر فارو"
            },
            {
                "id": 72,
                "country_ar": "فيجي"
            },
            {
                "id": 73,
                "country_ar": "فنلندا"
            },
            {
                "id": 74,
                "country_ar": "فرنسا"
            },
            {
                "id": 75,
                "country_ar": "غويانا الفرنسية"
            },
            {
                "id": 76,
                "country_ar": "بولينيزيا الفرنسية"
            },
            {
                "id": 78,
                "country_ar": "الغابون"
            },
            {
                "id": 79,
                "country_ar": "غامبيا"
            },
            {
                "id": 80,
                "country_ar": "جيورجيا"
            },
            {
                "id": 81,
                "country_ar": "ألمانيا"
            },
            {
                "id": 82,
                "country_ar": "غانا"
            },
            {
                "id": 83,
                "country_ar": "جبل طارق"
            },
            {
                "id": 84,
                "country_ar": "غيرنزي"
            },
            {
                "id": 85,
                "country_ar": "اليونان"
            },
            {
                "id": 86,
                "country_ar": "جرينلاند"
            },
            {
                "id": 87,
                "country_ar": "غرينادا"
            },
            {
                "id": 88,
                "country_ar": "جزر جوادلوب"
            },
            {
                "id": 89,
                "country_ar": "جوام"
            },
            {
                "id": 90,
                "country_ar": "غواتيمال"
            },
            {
                "id": 91,
                "country_ar": "غينيا"
            },
            {
                "id": 92,
                "country_ar": "غينيا-بيساو"
            },
            {
                "id": 93,
                "country_ar": "غيانا"
            },
            {
                "id": 94,
                "country_ar": "هايتي"
            },
            {
                "id": 95,
                "country_ar": "جزيرة هيرد وجزر ماكدونالد"
            },
            {
                "id": 96,
                "country_ar": "هندوراس"
            },
            {
                "id": 97,
                "country_ar": "هونغ كونغ"
            },
            {
                "id": 98,
                "country_ar": "المجر"
            },
            {
                "id": 99,
                "country_ar": "آيسلندا"
            },
            {
                "id": 100,
                "country_ar": "الهند"
            },
            {
                "id": 101,
                "country_ar": "جزيرة مان"
            },
            {
                "id": 102,
                "country_ar": "أندونيسيا"
            },
            {
                "id": 103,
                "country_ar": "إيران"
            },
            {
                "id": 105,
                "country_ar": "إيرلندا"
            },
            {
                "id": 106,
                "country_ar": "إيطاليا"
            },
            {
                "id": 107,
                "country_ar": "ساحل العاج"
            },
            {
                "id": 108,
                "country_ar": "جيرزي"
            },
            {
                "id": 109,
                "country_ar": "جمايكا"
            },
            {
                "id": 110,
                "country_ar": "اليابان"
            },
            {
                "id": 112,
                "country_ar": "كازاخستان"
            },
            {
                "id": 113,
                "country_ar": "كينيا"
            },
            {
                "id": 114,
                "country_ar": "كيريباتي"
            },
            {
                "id": 115,
                "country_ar": "كوريا الشمالية"
            },
            {
                "id": 116,
                "country_ar": "كوريا الجنوبية"
            },
            {
                "id": 117,
                "country_ar": "كوسوفو"
            },
            {
                "id": 119,
                "country_ar": "قيرغيزستان"
            },
            {
                "id": 120,
                "country_ar": "لاوس"
            },
            {
                "id": 121,
                "country_ar": "لاتفيا"
            },
            {
                "id": 123,
                "country_ar": "ليسوتو"
            },
            {
                "id": 124,
                "country_ar": "ليبيريا"
            },
            {
                "id": 126,
                "country_ar": "ليختنشتين"
            },
            {
                "id": 127,
                "country_ar": "لتوانيا"
            },
            {
                "id": 128,
                "country_ar": "لوكسمبورغ"
            },
            {
                "id": 129,
                "country_ar": "سريلانكا"
            },
            {
                "id": 130,
                "country_ar": "ماكاو"
            },
            {
                "id": 131,
                "country_ar": "مقدونيا"
            },
            {
                "id": 132,
                "country_ar": "مدغشقر"
            },
            {
                "id": 133,
                "country_ar": "مالاوي"
            },
            {
                "id": 134,
                "country_ar": "ماليزيا"
            },
            {
                "id": 135,
                "country_ar": "المالديف"
            },
            {
                "id": 136,
                "country_ar": "مالي"
            },
            {
                "id": 137,
                "country_ar": "مالطا"
            },
            {
                "id": 138,
                "country_ar": "جزر مارشال"
            },
            {
                "id": 139,
                "country_ar": "مارتينيك"
            },
            {
                "id": 141,
                "country_ar": "موريشيوس"
            },
            {
                "id": 142,
                "country_ar": "مايوت"
            },
            {
                "id": 143,
                "country_ar": "المكسيك"
            },
            {
                "id": 144,
                "country_ar": "مايكرونيزيا"
            },
            {
                "id": 145,
                "country_ar": "مولدافيا"
            },
            {
                "id": 146,
                "country_ar": "موناكو"
            },
            {
                "id": 147,
                "country_ar": "منغوليا"
            },
            {
                "id": 148,
                "country_ar": "الجبل الأسود"
            },
            {
                "id": 149,
                "country_ar": "مونتسيرات"
            },
            {
                "id": 151,
                "country_ar": "موزمبيق"
            },
            {
                "id": 152,
                "country_ar": "ميانمار"
            },
            {
                "id": 153,
                "country_ar": "ناميبيا"
            },
            {
                "id": 154,
                "country_ar": "نورو"
            },
            {
                "id": 155,
                "country_ar": "نيبال"
            },
            {
                "id": 156,
                "country_ar": "هولندا"
            },
            {
                "id": 157,
                "country_ar": "جزر الأنتيل الهولندي"
            },
            {
                "id": 158,
                "country_ar": "كاليدونيا الجديدة"
            },
            {
                "id": 159,
                "country_ar": "نيوزيلندا"
            },
            {
                "id": 160,
                "country_ar": "نيكاراجوا"
            },
            {
                "id": 161,
                "country_ar": "النيجر"
            },
            {
                "id": 162,
                "country_ar": "نيجيريا"
            },
            {
                "id": 163,
                "country_ar": "ني"
            },
            {
                "id": 164,
                "country_ar": "جزيرة نورفولك"
            },
            {
                "id": 165,
                "country_ar": "جزر ماريانا الشمالية"
            },
            {
                "id": 166,
                "country_ar": "النرويج"
            },
            {
                "id": 168,
                "country_ar": "باكستان"
            },
            {
                "id": 169,
                "country_ar": "بالاو"
            },
            {
                "id": 171,
                "country_ar": "بنما"
            },
            {
                "id": 172,
                "country_ar": "بابوا غينيا الجديدة"
            },
            {
                "id": 173,
                "country_ar": "باراغواي"
            },
            {
                "id": 174,
                "country_ar": "بيرو"
            },
            {
                "id": 175,
                "country_ar": "الفليبين"
            },
            {
                "id": 177,
                "country_ar": "بولونيا"
            },
            {
                "id": 178,
                "country_ar": "البرتغال"
            },
            {
                "id": 179,
                "country_ar": "بورتو ريكو"
            },
            {
                "id": 181,
                "country_ar": "ريونيون"
            },
            {
                "id": 182,
                "country_ar": "رومانيا"
            },
            {
                "id": 183,
                "country_ar": "روسيا"
            },
            {
                "id": 184,
                "country_ar": "رواندا"
            },
            {
                "id": 185,
                "country_ar": "سانت كيتس ونيفس"
            },
            {
                "id": 188,
                "country_ar": "سان بيير وميكلون"
            },
            {
                "id": 189,
                "country_ar": "سانت فنسنت وجزر غرينادين"
            },
            {
                "id": 190,
                "country_ar": "ساموا"
            },
            {
                "id": 191,
                "country_ar": "سان مارينو"
            },
            {
                "id": 192,
                "country_ar": "ساو تومي وبرينسيبي"
            },
            {
                "id": 194,
                "country_ar": "السنغال"
            },
            {
                "id": 195,
                "country_ar": "صربيا"
            },
            {
                "id": 196,
                "country_ar": "سيشيل"
            },
            {
                "id": 197,
                "country_ar": "سيراليون"
            },
            {
                "id": 198,
                "country_ar": "سنغافورة"
            },
            {
                "id": 199,
                "country_ar": "سلوفاكيا"
            },
            {
                "id": 200,
                "country_ar": "سلوفينيا"
            },
            {
                "id": 201,
                "country_ar": "جزر سليمان"
            },
            {
                "id": 203,
                "country_ar": "جنوب أفريقيا"
            },
            {
                "id": 205,
                "country_ar": "السودان الجنوبي"
            },
            {
                "id": 206,
                "country_ar": "إسبانيا"
            },
            {
                "id": 207,
                "country_ar": "سانت هيلانة"
            },
            {
                "id": 209,
                "country_ar": "سورينام"
            },
            {
                "id": 210,
                "country_ar": "سفالبارد ويان ماين"
            },
            {
                "id": 212,
                "country_ar": "السويد"
            },
            {
                "id": 213,
                "country_ar": "سويسرا"
            },
            {
                "id": 215,
                "country_ar": "تايوان"
            },
            {
                "id": 216,
                "country_ar": "طاجيكستان"
            },
            {
                "id": 217,
                "country_ar": "تنزانيا"
            },
            {
                "id": 218,
                "country_ar": "تايلندا"
            },
            {
                "id": 219,
                "country_ar": "تيمور الشرقية"
            },
            {
                "id": 220,
                "country_ar": "توغو"
            },
            {
                "id": 221,
                "country_ar": "توكيلاو"
            },
            {
                "id": 222,
                "country_ar": "تونغا"
            },
            {
                "id": 223,
                "country_ar": "ترينيداد وتوباغو"
            },
            {
                "id": 225,
                "country_ar": "تركيا"
            },
            {
                "id": 226,
                "country_ar": "تركمانستان"
            },
            {
                "id": 227,
                "country_ar": "جزر توركس وكايكوس"
            },
            {
                "id": 228,
                "country_ar": "توفالو"
            },
            {
                "id": 229,
                "country_ar": "أوغندا"
            },
            {
                "id": 230,
                "country_ar": "أوكرانيا"
            },
            {
                "id": 232,
                "country_ar": "المملكة المتحدة"
            },
            {
                "id": 233,
                "country_ar": "الولايات المتحدة"
            },
            {
                "id": 235,
                "country_ar": "أورغواي"
            },
            {
                "id": 236,
                "country_ar": "أوزباكستان"
            },
            {
                "id": 237,
                "country_ar": "فانواتو"
            },
            {
                "id": 238,
                "country_ar": "فنزويلا"
            },
            {
                "id": 239,
                "country_ar": "فيتنام"
            },
            {
                "id": 241,
                "country_ar": "فنزويلا"
            },
            {
                "id": 243,
                "country_ar": "الصحراء الغربية"
            },
            {
                "id": 245,
                "country_ar": "زامبيا"
            },
            {
                "id": 246,
                "country_ar": "زمبابوي"
            }
        ],
        "nationalites_ar": [
            {
                "id": 18,
                "nationality_ar": "بحريني"
            },
            {
                "id": 104,
                "nationality_ar": "عراقي"
            },
            {
                "id": 111,
                "nationality_ar": "أردني"
            },
            {
                "id": 118,
                "nationality_ar": "كويتي"
            },
            {
                "id": 122,
                "nationality_ar": "لبناني"
            },
            {
                "id": 167,
                "nationality_ar": "عماني"
            },
            {
                "id": 170,
                "nationality_ar": "فلسطيني"
            },
            {
                "id": 180,
                "nationality_ar": "قطري"
            },
            {
                "id": 193,
                "nationality_ar": "سعودي"
            },
            {
                "id": 214,
                "nationality_ar": "سوري"
            },
            {
                "id": 231,
                "nationality_ar": "إماراتي"
            },
            {
                "id": 244,
                "nationality_ar": "يمني"
            },
            {
                "id": 4,
                "nationality_ar": "جزائري"
            },
            {
                "id": 60,
                "nationality_ar": "جيبوتي"
            },
            {
                "id": 64,
                "nationality_ar": "مصري"
            },
            {
                "id": 125,
                "nationality_ar": "ليبي"
            },
            {
                "id": 140,
                "nationality_ar": "موريتانيي"
            },
            {
                "id": 150,
                "nationality_ar": "مغربي"
            },
            {
                "id": 202,
                "nationality_ar": "صومالي"
            },
            {
                "id": 208,
                "nationality_ar": "سوداني"
            },
            {
                "id": 224,
                "nationality_ar": "تونسي"
            },
            {
                "id": 44,
                "nationality_ar": "تشادي"
            },
            {
                "id": 50,
                "nationality_ar": "جزر القمر"
            },
            {
                "id": 1,
                "nationality_ar": "أفغانستاني"
            },
            {
                "id": 2,
                "nationality_ar": "ألباني"
            },
            {
                "id": 3,
                "nationality_ar": "آلاندي"
            },
            {
                "id": 5,
                "nationality_ar": "أمريكي سامواني"
            },
            {
                "id": 6,
                "nationality_ar": "أندوري"
            },
            {
                "id": 7,
                "nationality_ar": "أنقولي"
            },
            {
                "id": 8,
                "nationality_ar": "أنغويلي"
            },
            {
                "id": 9,
                "nationality_ar": "أنتاركتيكي"
            },
            {
                "id": 10,
                "nationality_ar": "بربودي"
            },
            {
                "id": 11,
                "nationality_ar": "أرجنتيني"
            },
            {
                "id": 12,
                "nationality_ar": "أرميني"
            },
            {
                "id": 13,
                "nationality_ar": "أوروبهيني"
            },
            {
                "id": 14,
                "nationality_ar": "أسترالي"
            },
            {
                "id": 15,
                "nationality_ar": "نمساوي"
            },
            {
                "id": 16,
                "nationality_ar": "أذربيجاني"
            },
            {
                "id": 17,
                "nationality_ar": "باهاميسي"
            },
            {
                "id": 19,
                "nationality_ar": "بنغلاديشي"
            },
            {
                "id": 20,
                "nationality_ar": "بربادوسي"
            },
            {
                "id": 21,
                "nationality_ar": "روسي"
            },
            {
                "id": 22,
                "nationality_ar": "بلجيكي"
            },
            {
                "id": 23,
                "nationality_ar": "بيليزي"
            },
            {
                "id": 24,
                "nationality_ar": "بنيني"
            },
            {
                "id": 25,
                "nationality_ar": "سان بارتيلمي"
            },
            {
                "id": 26,
                "nationality_ar": "برمودي"
            },
            {
                "id": 27,
                "nationality_ar": "بوتاني"
            },
            {
                "id": 28,
                "nationality_ar": "بوليفي"
            },
            {
                "id": 29,
                "nationality_ar": "بوسني/هرسكي"
            },
            {
                "id": 30,
                "nationality_ar": "بوتسواني"
            },
            {
                "id": 31,
                "nationality_ar": "بوفيهي"
            },
            {
                "id": 32,
                "nationality_ar": "برازيلي"
            },
            {
                "id": 33,
                "nationality_ar": "إقليم المحيط الهندي البريطاني"
            },
            {
                "id": 35,
                "nationality_ar": "بلغاري"
            },
            {
                "id": 36,
                "nationality_ar": "بوركيني"
            },
            {
                "id": 37,
                "nationality_ar": "بورونيدي"
            },
            {
                "id": 38,
                "nationality_ar": "كمبودي"
            },
            {
                "id": 39,
                "nationality_ar": "كاميروني"
            },
            {
                "id": 40,
                "nationality_ar": "كندي"
            },
            {
                "id": 42,
                "nationality_ar": "كايماني"
            },
            {
                "id": 43,
                "nationality_ar": "أفريقي"
            },
            {
                "id": 45,
                "nationality_ar": "شيلي"
            },
            {
                "id": 46,
                "nationality_ar": "صيني"
            },
            {
                "id": 47,
                "nationality_ar": "جزيرة عيد الميلاد"
            },
            {
                "id": 48,
                "nationality_ar": "جزر كوكوس"
            },
            {
                "id": 49,
                "nationality_ar": "كولومبي"
            },
            {
                "id": 52,
                "nationality_ar": "جزر كوك"
            },
            {
                "id": 53,
                "nationality_ar": "كوستاريكي"
            },
            {
                "id": 54,
                "nationality_ar": "كوراتي"
            },
            {
                "id": 55,
                "nationality_ar": "كوبي"
            },
            {
                "id": 56,
                "nationality_ar": "قبرصي"
            },
            {
                "id": 57,
                "nationality_ar": "كوراساوي"
            },
            {
                "id": 58,
                "nationality_ar": "تشيكي"
            },
            {
                "id": 59,
                "nationality_ar": "دنماركي"
            },
            {
                "id": 61,
                "nationality_ar": "دومينيكي"
            },
            {
                "id": 62,
                "nationality_ar": "دومينيكي"
            },
            {
                "id": 63,
                "nationality_ar": "إكوادوري"
            },
            {
                "id": 65,
                "nationality_ar": "سلفادوري"
            },
            {
                "id": 66,
                "nationality_ar": "غيني"
            },
            {
                "id": 67,
                "nationality_ar": "إريتيري"
            },
            {
                "id": 68,
                "nationality_ar": "استوني"
            },
            {
                "id": 69,
                "nationality_ar": "أثيوبي"
            },
            {
                "id": 70,
                "nationality_ar": "فوكلاندي"
            },
            {
                "id": 71,
                "nationality_ar": "جزر فارو"
            },
            {
                "id": 72,
                "nationality_ar": "فيجي"
            },
            {
                "id": 73,
                "nationality_ar": "فنلندي"
            },
            {
                "id": 74,
                "nationality_ar": "فرنسي"
            },
            {
                "id": 75,
                "nationality_ar": "غويانا الفرنسية"
            },
            {
                "id": 76,
                "nationality_ar": "بولينيزيي"
            },
            {
                "id": 78,
                "nationality_ar": "غابوني"
            },
            {
                "id": 79,
                "nationality_ar": "غامبي"
            },
            {
                "id": 80,
                "nationality_ar": "جيورجي"
            },
            {
                "id": 81,
                "nationality_ar": "ألماني"
            },
            {
                "id": 82,
                "nationality_ar": "غاني"
            },
            {
                "id": 83,
                "nationality_ar": "جبل طارق"
            },
            {
                "id": 84,
                "nationality_ar": "غيرنزي"
            },
            {
                "id": 85,
                "nationality_ar": "يوناني"
            },
            {
                "id": 86,
                "nationality_ar": "جرينلاندي"
            },
            {
                "id": 87,
                "nationality_ar": "غرينادي"
            },
            {
                "id": 88,
                "nationality_ar": "جزر جوادلوب"
            },
            {
                "id": 89,
                "nationality_ar": "جوامي"
            },
            {
                "id": 90,
                "nationality_ar": "غواتيمالي"
            },
            {
                "id": 91,
                "nationality_ar": "غيني"
            },
            {
                "id": 92,
                "nationality_ar": "غيني"
            },
            {
                "id": 93,
                "nationality_ar": "غياني"
            },
            {
                "id": 94,
                "nationality_ar": "هايتي"
            },
            {
                "id": 95,
                "nationality_ar": "جزيرة هيرد وجزر ماكدونالد"
            },
            {
                "id": 96,
                "nationality_ar": "هندوراسي"
            },
            {
                "id": 97,
                "nationality_ar": "هونغ كونغي"
            },
            {
                "id": 98,
                "nationality_ar": "مجري"
            },
            {
                "id": 99,
                "nationality_ar": "آيسلندي"
            },
            {
                "id": 100,
                "nationality_ar": "هندي"
            },
            {
                "id": 101,
                "nationality_ar": "ماني"
            },
            {
                "id": 102,
                "nationality_ar": "أندونيسيي"
            },
            {
                "id": 103,
                "nationality_ar": "إيراني"
            },
            {
                "id": 105,
                "nationality_ar": "إيرلندي"
            },
            {
                "id": 106,
                "nationality_ar": "إيطالي"
            },
            {
                "id": 107,
                "nationality_ar": "ساحل العاج"
            },
            {
                "id": 108,
                "nationality_ar": "جيرزي"
            },
            {
                "id": 109,
                "nationality_ar": "جمايكي"
            },
            {
                "id": 110,
                "nationality_ar": "ياباني"
            },
            {
                "id": 112,
                "nationality_ar": "كازاخستاني"
            },
            {
                "id": 113,
                "nationality_ar": "كيني"
            },
            {
                "id": 114,
                "nationality_ar": "كيريباتي"
            },
            {
                "id": 115,
                "nationality_ar": "كوري"
            },
            {
                "id": 116,
                "nationality_ar": "كوري"
            },
            {
                "id": 117,
                "nationality_ar": "كوسيفي"
            },
            {
                "id": 119,
                "nationality_ar": "قيرغيزستاني"
            },
            {
                "id": 120,
                "nationality_ar": "لاوسي"
            },
            {
                "id": 121,
                "nationality_ar": "لاتيفي"
            },
            {
                "id": 123,
                "nationality_ar": "ليوسيتي"
            },
            {
                "id": 124,
                "nationality_ar": "ليبيري"
            },
            {
                "id": 126,
                "nationality_ar": "ليختنشتيني"
            },
            {
                "id": 127,
                "nationality_ar": "لتوانيي"
            },
            {
                "id": 128,
                "nationality_ar": "لوكسمبورغي"
            },
            {
                "id": 129,
                "nationality_ar": "سريلانكي"
            },
            {
                "id": 130,
                "nationality_ar": "ماكاوي"
            },
            {
                "id": 131,
                "nationality_ar": "مقدوني"
            },
            {
                "id": 132,
                "nationality_ar": "مدغشقري"
            },
            {
                "id": 133,
                "nationality_ar": "مالاوي"
            },
            {
                "id": 134,
                "nationality_ar": "ماليزي"
            },
            {
                "id": 135,
                "nationality_ar": "مالديفي"
            },
            {
                "id": 136,
                "nationality_ar": "مالي"
            },
            {
                "id": 137,
                "nationality_ar": "مالطي"
            },
            {
                "id": 138,
                "nationality_ar": "مارشالي"
            },
            {
                "id": 139,
                "nationality_ar": "مارتينيكي"
            },
            {
                "id": 141,
                "nationality_ar": "موريشيوسي"
            },
            {
                "id": 142,
                "nationality_ar": "مايوتي"
            },
            {
                "id": 143,
                "nationality_ar": "مكسيكي"
            },
            {
                "id": 144,
                "nationality_ar": "مايكرونيزيي"
            },
            {
                "id": 145,
                "nationality_ar": "مولديفي"
            },
            {
                "id": 146,
                "nationality_ar": "مونيكي"
            },
            {
                "id": 147,
                "nationality_ar": "منغولي"
            },
            {
                "id": 148,
                "nationality_ar": "الجبل الأسود"
            },
            {
                "id": 149,
                "nationality_ar": "مونتسيراتي"
            },
            {
                "id": 151,
                "nationality_ar": "موزمبيقي"
            },
            {
                "id": 152,
                "nationality_ar": "ميانماري"
            },
            {
                "id": 153,
                "nationality_ar": "ناميبي"
            },
            {
                "id": 154,
                "nationality_ar": "نوري"
            },
            {
                "id": 155,
                "nationality_ar": "نيبالي"
            },
            {
                "id": 156,
                "nationality_ar": "هولندي"
            },
            {
                "id": 157,
                "nationality_ar": "هولندي"
            },
            {
                "id": 158,
                "nationality_ar": "كاليدوني"
            },
            {
                "id": 159,
                "nationality_ar": "نيوزيلندي"
            },
            {
                "id": 160,
                "nationality_ar": "نيكاراجوي"
            },
            {
                "id": 161,
                "nationality_ar": "نيجيري"
            },
            {
                "id": 162,
                "nationality_ar": "نيجيري"
            },
            {
                "id": 163,
                "nationality_ar": "ني"
            },
            {
                "id": 164,
                "nationality_ar": "نورفوليكي"
            },
            {
                "id": 165,
                "nationality_ar": "ماريني"
            },
            {
                "id": 166,
                "nationality_ar": "نرويجي"
            },
            {
                "id": 168,
                "nationality_ar": "باكستاني"
            },
            {
                "id": 169,
                "nationality_ar": "بالاوي"
            },
            {
                "id": 171,
                "nationality_ar": "بنمي"
            },
            {
                "id": 172,
                "nationality_ar": "بابوي"
            },
            {
                "id": 173,
                "nationality_ar": "بارغاوي"
            },
            {
                "id": 174,
                "nationality_ar": "بيري"
            },
            {
                "id": 175,
                "nationality_ar": "فلبيني"
            },
            {
                "id": 177,
                "nationality_ar": "بوليني"
            },
            {
                "id": 178,
                "nationality_ar": "برتغالي"
            },
            {
                "id": 179,
                "nationality_ar": "بورتي"
            },
            {
                "id": 181,
                "nationality_ar": "ريونيوني"
            },
            {
                "id": 182,
                "nationality_ar": "روماني"
            },
            {
                "id": 183,
                "nationality_ar": "روسي"
            },
            {
                "id": 184,
                "nationality_ar": "رواندا"
            },
            {
                "id": 185,
                "nationality_ar": "كيتيني/نيفيسي"
            },
            {
                "id": 188,
                "nationality_ar": "سان بيير وميكلوني"
            },
            {
                "id": 189,
                "nationality_ar": "سانت فنسنت وجزر غرينادين"
            },
            {
                "id": 190,
                "nationality_ar": "ساموي"
            },
            {
                "id": 191,
                "nationality_ar": "ماريني"
            },
            {
                "id": 192,
                "nationality_ar": "ساو تومي وبرينسيبي"
            },
            {
                "id": 194,
                "nationality_ar": "سنغالي"
            },
            {
                "id": 195,
                "nationality_ar": "صربي"
            },
            {
                "id": 196,
                "nationality_ar": "سيشيلي"
            },
            {
                "id": 197,
                "nationality_ar": "سيراليوني"
            },
            {
                "id": 198,
                "nationality_ar": "سنغافوري"
            },
            {
                "id": 199,
                "nationality_ar": "سولفاكي"
            },
            {
                "id": 200,
                "nationality_ar": "سولفيني"
            },
            {
                "id": 201,
                "nationality_ar": "جزر سليمان"
            },
            {
                "id": 203,
                "nationality_ar": "أفريقي"
            },
            {
                "id": 205,
                "nationality_ar": "سوادني جنوبي"
            },
            {
                "id": 206,
                "nationality_ar": "إسباني"
            },
            {
                "id": 207,
                "nationality_ar": "هيلاني"
            },
            {
                "id": 209,
                "nationality_ar": "سورينامي"
            },
            {
                "id": 210,
                "nationality_ar": "سفالبارد ويان ماين"
            },
            {
                "id": 212,
                "nationality_ar": "سويدي"
            },
            {
                "id": 213,
                "nationality_ar": "سويسري"
            },
            {
                "id": 215,
                "nationality_ar": "تايواني"
            },
            {
                "id": 216,
                "nationality_ar": "طاجيكستاني"
            },
            {
                "id": 217,
                "nationality_ar": "تنزانيي"
            },
            {
                "id": 218,
                "nationality_ar": "تايلندي"
            },
            {
                "id": 219,
                "nationality_ar": "تيموري"
            },
            {
                "id": 220,
                "nationality_ar": "توغي"
            },
            {
                "id": 221,
                "nationality_ar": "توكيلاوي"
            },
            {
                "id": 222,
                "nationality_ar": "تونغي"
            },
            {
                "id": 223,
                "nationality_ar": "ترينيداد وتوباغو"
            },
            {
                "id": 225,
                "nationality_ar": "تركي"
            },
            {
                "id": 226,
                "nationality_ar": "تركمانستاني"
            },
            {
                "id": 227,
                "nationality_ar": "جزر توركس وكايكوس"
            },
            {
                "id": 228,
                "nationality_ar": "توفالي"
            },
            {
                "id": 229,
                "nationality_ar": "أوغندي"
            },
            {
                "id": 230,
                "nationality_ar": "أوكراني"
            },
            {
                "id": 232,
                "nationality_ar": "بريطاني"
            },
            {
                "id": 233,
                "nationality_ar": "أمريكي"
            },
            {
                "id": 235,
                "nationality_ar": "أورغواي"
            },
            {
                "id": 236,
                "nationality_ar": "أوزباكستاني"
            },
            {
                "id": 237,
                "nationality_ar": "فانواتي"
            },
            {
                "id": 238,
                "nationality_ar": "فنزويلي"
            },
            {
                "id": 239,
                "nationality_ar": "فيتنامي"
            },
            {
                "id": 241,
                "nationality_ar": "فاتيكاني"
            },
            {
                "id": 243,
                "nationality_ar": "صحراوي"
            },
            {
                "id": 245,
                "nationality_ar": "زامبياني"
            },
            {
                "id": 246,
                "nationality_ar": "زمبابوي"
            }
        ],
        "countries_phones": [
            {
                "country_ar": "البحرين",
                "phone_code": "+973"
            },
            {
                "country_ar": "العراق",
                "phone_code": "+964"
            },
            {
                "country_ar": "الأردن",
                "phone_code": "+962"
            },
            {
                "country_ar": "الكويت",
                "phone_code": "+965"
            },
            {
                "country_ar": "لبنان",
                "phone_code": "+961"
            },
            {
                "country_ar": "عمان",
                "phone_code": "+968"
            },
            {
                "country_ar": "فلسطين",
                "phone_code": "+970"
            },
            {
                "country_ar": "قطر",
                "phone_code": "+974"
            },
            {
                "country_ar": "المملكة العربية السعودية",
                "phone_code": "+966"
            },
            {
                "country_ar": "سوريا",
                "phone_code": "+963"
            },
            {
                "country_ar": "الإمارات العربية المتحدة",
                "phone_code": "+971"
            },
            {
                "country_ar": "اليمن",
                "phone_code": "+967"
            },
            {
                "country_ar": "الجزائر",
                "phone_code": "+213"
            },
            {
                "country_ar": "جيبوتي",
                "phone_code": "+253"
            },
            {
                "country_ar": "مصر",
                "phone_code": "+20"
            },
            {
                "country_ar": "ليبيا",
                "phone_code": "+218"
            },
            {
                "country_ar": "موريتانيا",
                "phone_code": "+222"
            },
            {
                "country_ar": "المغرب",
                "phone_code": "+212"
            },
            {
                "country_ar": "الصومال",
                "phone_code": "+252"
            },
            {
                "country_ar": "السودان",
                "phone_code": "+249"
            },
            {
                "country_ar": "تونس",
                "phone_code": "+216"
            },
            {
                "country_ar": "تشاد",
                "phone_code": "+235"
            },
            {
                "country_ar": "جزر القمر",
                "phone_code": "+269"
            },
            {
                "country_ar": "أفغانستان",
                "phone_code": "+93"
            },
            {
                "country_ar": "ألبانيا",
                "phone_code": "+355"
            },
            {
                "country_ar": "جزر آلاند",
                "phone_code": "+358"
            },
            {
                "country_ar": "ساموا-الأمريكي",
                "phone_code": "+684"
            },
            {
                "country_ar": "أندورا",
                "phone_code": "+376"
            },
            {
                "country_ar": "أنغولا",
                "phone_code": "+244"
            },
            {
                "country_ar": "أنغويلا",
                "phone_code": "+264"
            },
            {
                "country_ar": "أنتاركتيكا",
                "phone_code": "+672"
            },
            {
                "country_ar": "أنتيغوا وبربودا",
                "phone_code": "+268"
            },
            {
                "country_ar": "الأرجنتين",
                "phone_code": "+54"
            },
            {
                "country_ar": "أرمينيا",
                "phone_code": "+374"
            },
            {
                "country_ar": "أروبه",
                "phone_code": "+297"
            },
            {
                "country_ar": "أستراليا",
                "phone_code": "+61"
            },
            {
                "country_ar": "النمسا",
                "phone_code": "+43"
            },
            {
                "country_ar": "أذربيجان",
                "phone_code": "+994"
            },
            {
                "country_ar": "الباهاماس",
                "phone_code": "+1"
            },
            {
                "country_ar": "بنغلاديش",
                "phone_code": "+880"
            },
            {
                "country_ar": "بربادوس",
                "phone_code": "+246"
            },
            {
                "country_ar": "روسيا البيضاء",
                "phone_code": "+375"
            },
            {
                "country_ar": "بلجيكا",
                "phone_code": "+32"
            },
            {
                "country_ar": "بيليز",
                "phone_code": "+501"
            },
            {
                "country_ar": "بنين",
                "phone_code": "+229"
            },
            {
                "country_ar": "سان بارتيلمي",
                "phone_code": "+590"
            },
            {
                "country_ar": "جزر برمودا",
                "phone_code": "+1"
            },
            {
                "country_ar": "بوتان",
                "phone_code": "+975"
            },
            {
                "country_ar": "بوليفيا",
                "phone_code": "+591"
            },
            {
                "country_ar": "البوسنة و الهرسك",
                "phone_code": "+387"
            },
            {
                "country_ar": "بوتسوانا",
                "phone_code": "+267"
            },
            {
                "country_ar": "جزيرة بوفيه",
                "phone_code": "+47"
            },
            {
                "country_ar": "البرازيل",
                "phone_code": "+55"
            },
            {
                "country_ar": "إقليم المحيط الهندي البريطاني",
                "phone_code": "+246"
            },
            {
                "country_ar": "بلغاريا",
                "phone_code": "+359"
            },
            {
                "country_ar": "بوركينا فاسو",
                "phone_code": "+226"
            },
            {
                "country_ar": "بوروندي",
                "phone_code": "+257"
            },
            {
                "country_ar": "كمبوديا",
                "phone_code": "+855"
            },
            {
                "country_ar": "كاميرون",
                "phone_code": "+237"
            },
            {
                "country_ar": "كندا",
                "phone_code": "+1"
            },
            {
                "country_ar": "جزر كايمان",
                "phone_code": "+1345"
            },
            {
                "country_ar": "جمهورية أفريقيا الوسطى",
                "phone_code": "+236"
            },
            {
                "country_ar": "شيلي",
                "phone_code": "+56"
            },
            {
                "country_ar": "الصين",
                "phone_code": "+86"
            },
            {
                "country_ar": "جزيرة عيد الميلاد",
                "phone_code": "+61"
            },
            {
                "country_ar": "جزر كوكوس",
                "phone_code": "+61"
            },
            {
                "country_ar": "كولومبيا",
                "phone_code": "+57"
            },
            {
                "country_ar": "جزر كوك",
                "phone_code": "+682"
            },
            {
                "country_ar": "كوستاريكا",
                "phone_code": "+506"
            },
            {
                "country_ar": "كرواتيا",
                "phone_code": "+385"
            },
            {
                "country_ar": "كوبا",
                "phone_code": "+53"
            },
            {
                "country_ar": "قبرص",
                "phone_code": "+357"
            },
            {
                "country_ar": "كوراساو",
                "phone_code": "+599"
            },
            {
                "country_ar": "الجمهورية التشيكية",
                "phone_code": "+420"
            },
            {
                "country_ar": "الدانمارك",
                "phone_code": "+45"
            },
            {
                "country_ar": "دومينيكا",
                "phone_code": "+767"
            },
            {
                "country_ar": "الجمهورية الدومينيكية",
                "phone_code": "+1"
            },
            {
                "country_ar": "إكوادور",
                "phone_code": "+593"
            },
            {
                "country_ar": "إلسلفادور",
                "phone_code": "+503"
            },
            {
                "country_ar": "غينيا الاستوائي",
                "phone_code": "+240"
            },
            {
                "country_ar": "إريتريا",
                "phone_code": "+291"
            },
            {
                "country_ar": "استونيا",
                "phone_code": "+372"
            },
            {
                "country_ar": "أثيوبيا",
                "phone_code": "+251"
            },
            {
                "country_ar": "جزر فوكلاند",
                "phone_code": "+500"
            },
            {
                "country_ar": "جزر فارو",
                "phone_code": "+298"
            },
            {
                "country_ar": "فيجي",
                "phone_code": "+679"
            },
            {
                "country_ar": "فنلندا",
                "phone_code": "+358"
            },
            {
                "country_ar": "فرنسا",
                "phone_code": "+33"
            },
            {
                "country_ar": "غويانا الفرنسية",
                "phone_code": "+594"
            },
            {
                "country_ar": "بولينيزيا الفرنسية",
                "phone_code": "+689"
            },
            {
                "country_ar": "الغابون",
                "phone_code": "+241"
            },
            {
                "country_ar": "غامبيا",
                "phone_code": "+220"
            },
            {
                "country_ar": "جيورجيا",
                "phone_code": "+995"
            },
            {
                "country_ar": "ألمانيا",
                "phone_code": "+49"
            },
            {
                "country_ar": "غانا",
                "phone_code": "+233"
            },
            {
                "country_ar": "جبل طارق",
                "phone_code": "+350"
            },
            {
                "country_ar": "غيرنزي",
                "phone_code": "+44"
            },
            {
                "country_ar": "اليونان",
                "phone_code": "+30"
            },
            {
                "country_ar": "جرينلاند",
                "phone_code": "+299"
            },
            {
                "country_ar": "غرينادا",
                "phone_code": "+473"
            },
            {
                "country_ar": "جزر جوادلوب",
                "phone_code": "+590"
            },
            {
                "country_ar": "جوام",
                "phone_code": "+1"
            },
            {
                "country_ar": "غواتيمال",
                "phone_code": "+502"
            },
            {
                "country_ar": "غينيا",
                "phone_code": "+224"
            },
            {
                "country_ar": "غينيا-بيساو",
                "phone_code": "+245"
            },
            {
                "country_ar": "غيانا",
                "phone_code": "+592"
            },
            {
                "country_ar": "هايتي",
                "phone_code": "+509"
            },
            {
                "country_ar": "جزيرة هيرد وجزر ماكدونالد",
                "phone_code": "+672"
            },
            {
                "country_ar": "هندوراس",
                "phone_code": "+504"
            },
            {
                "country_ar": "هونغ كونغ",
                "phone_code": "+852"
            },
            {
                "country_ar": "المجر",
                "phone_code": "+36"
            },
            {
                "country_ar": "آيسلندا",
                "phone_code": "+354"
            },
            {
                "country_ar": "الهند",
                "phone_code": "+91"
            },
            {
                "country_ar": "جزيرة مان",
                "phone_code": "+44"
            },
            {
                "country_ar": "أندونيسيا",
                "phone_code": "+62"
            },
            {
                "country_ar": "إيران",
                "phone_code": "+98"
            },
            {
                "country_ar": "إيرلندا",
                "phone_code": "+353"
            },
            {
                "country_ar": "إيطاليا",
                "phone_code": "+390"
            },
            {
                "country_ar": "ساحل العاج",
                "phone_code": "+225"
            },
            {
                "country_ar": "جيرزي",
                "phone_code": "+44"
            },
            {
                "country_ar": "جمايكا",
                "phone_code": "+1876"
            },
            {
                "country_ar": "اليابان",
                "phone_code": "+81"
            },
            {
                "country_ar": "كازاخستان",
                "phone_code": "+7"
            },
            {
                "country_ar": "كينيا",
                "phone_code": "+254"
            },
            {
                "country_ar": "كيريباتي",
                "phone_code": "+686"
            },
            {
                "country_ar": "كوريا الشمالية",
                "phone_code": "+850"
            },
            {
                "country_ar": "كوريا الجنوبية",
                "phone_code": "+82"
            },
            {
                "country_ar": "كوسوفو",
                "phone_code": "+383"
            },
            {
                "country_ar": "قيرغيزستان",
                "phone_code": "+996"
            },
            {
                "country_ar": "لاوس",
                "phone_code": "+856"
            },
            {
                "country_ar": "لاتفيا",
                "phone_code": "+371"
            },
            {
                "country_ar": "ليسوتو",
                "phone_code": "+266"
            },
            {
                "country_ar": "ليبيريا",
                "phone_code": "+231"
            },
            {
                "country_ar": "ليختنشتين",
                "phone_code": "+423"
            },
            {
                "country_ar": "لتوانيا",
                "phone_code": "+370"
            },
            {
                "country_ar": "لوكسمبورغ",
                "phone_code": "+352"
            },
            {
                "country_ar": "سريلانكا",
                "phone_code": "+94"
            },
            {
                "country_ar": "ماكاو",
                "phone_code": "+853"
            },
            {
                "country_ar": "مقدونيا",
                "phone_code": "+389"
            },
            {
                "country_ar": "مدغشقر",
                "phone_code": "+261"
            },
            {
                "country_ar": "مالاوي",
                "phone_code": "+265"
            },
            {
                "country_ar": "ماليزيا",
                "phone_code": "+60"
            },
            {
                "country_ar": "المالديف",
                "phone_code": "+960"
            },
            {
                "country_ar": "مالي",
                "phone_code": "+223"
            },
            {
                "country_ar": "مالطا",
                "phone_code": "+356"
            },
            {
                "country_ar": "جزر مارشال",
                "phone_code": "+692"
            },
            {
                "country_ar": "مارتينيك",
                "phone_code": "+33"
            },
            {
                "country_ar": "موريشيوس",
                "phone_code": "+230"
            },
            {
                "country_ar": "مايوت",
                "phone_code": "+262"
            },
            {
                "country_ar": "المكسيك",
                "phone_code": "+52"
            },
            {
                "country_ar": "مايكرونيزيا",
                "phone_code": "+691"
            },
            {
                "country_ar": "مولدافيا",
                "phone_code": "+373"
            },
            {
                "country_ar": "موناكو",
                "phone_code": "+377"
            },
            {
                "country_ar": "منغوليا",
                "phone_code": "+976"
            },
            {
                "country_ar": "الجبل الأسود",
                "phone_code": "+382"
            },
            {
                "country_ar": "مونتسيرات",
                "phone_code": "+1664"
            },
            {
                "country_ar": "موزمبيق",
                "phone_code": "+258"
            },
            {
                "country_ar": "ميانمار",
                "phone_code": "+95"
            },
            {
                "country_ar": "ناميبيا",
                "phone_code": "+264"
            },
            {
                "country_ar": "نورو",
                "phone_code": "+674"
            },
            {
                "country_ar": "نيبال",
                "phone_code": "+977"
            },
            {
                "country_ar": "هولندا",
                "phone_code": "+31"
            },
            {
                "country_ar": "جزر الأنتيل الهولندي",
                "phone_code": "+599"
            },
            {
                "country_ar": "كاليدونيا الجديدة",
                "phone_code": "+687"
            },
            {
                "country_ar": "نيوزيلندا",
                "phone_code": "+64"
            },
            {
                "country_ar": "نيكاراجوا",
                "phone_code": "+505"
            },
            {
                "country_ar": "النيجر",
                "phone_code": "+227"
            },
            {
                "country_ar": "نيجيريا",
                "phone_code": "+234"
            },
            {
                "country_ar": "ني",
                "phone_code": "+683"
            },
            {
                "country_ar": "جزيرة نورفولك",
                "phone_code": "+6723"
            },
            {
                "country_ar": "جزر ماريانا الشمالية",
                "phone_code": "+1"
            },
            {
                "country_ar": "النرويج",
                "phone_code": "+47"
            },
            {
                "country_ar": "باكستان",
                "phone_code": "+92"
            },
            {
                "country_ar": "بالاو",
                "phone_code": "+680"
            },
            {
                "country_ar": "بنما",
                "phone_code": "+507"
            },
            {
                "country_ar": "بابوا غينيا الجديدة",
                "phone_code": "+675"
            },
            {
                "country_ar": "باراغواي",
                "phone_code": "+595"
            },
            {
                "country_ar": "بيرو",
                "phone_code": "+51"
            },
            {
                "country_ar": "الفليبين",
                "phone_code": "+63"
            },
            {
                "country_ar": "بولونيا",
                "phone_code": "+48"
            },
            {
                "country_ar": "البرتغال",
                "phone_code": "+351"
            },
            {
                "country_ar": "بورتو ريكو",
                "phone_code": "+1787"
            },
            {
                "country_ar": "ريونيون",
                "phone_code": "+262"
            },
            {
                "country_ar": "رومانيا",
                "phone_code": "+40"
            },
            {
                "country_ar": "روسيا",
                "phone_code": "+7"
            },
            {
                "country_ar": "رواندا",
                "phone_code": "+250"
            },
            {
                "country_ar": "سانت كيتس ونيفس",
                "phone_code": "+1869"
            },
            {
                "country_ar": "سان بيير وميكلون",
                "phone_code": "+508"
            },
            {
                "country_ar": "سانت فنسنت وجزر غرينادين",
                "phone_code": "+784"
            },
            {
                "country_ar": "ساموا",
                "phone_code": "+685"
            },
            {
                "country_ar": "سان مارينو",
                "phone_code": "+378"
            },
            {
                "country_ar": "ساو تومي وبرينسيبي",
                "phone_code": "+239"
            },
            {
                "country_ar": "السنغال",
                "phone_code": "+221"
            },
            {
                "country_ar": "صربيا",
                "phone_code": "+381"
            },
            {
                "country_ar": "سيشيل",
                "phone_code": "+248"
            },
            {
                "country_ar": "سيراليون",
                "phone_code": "+232"
            },
            {
                "country_ar": "سنغافورة",
                "phone_code": "+65"
            },
            {
                "country_ar": "سلوفاكيا",
                "phone_code": "+421"
            },
            {
                "country_ar": "سلوفينيا",
                "phone_code": "+386"
            },
            {
                "country_ar": "جزر سليمان",
                "phone_code": "+677"
            },
            {
                "country_ar": "جنوب أفريقيا",
                "phone_code": "+27"
            },
            {
                "country_ar": "السودان الجنوبي",
                "phone_code": "+211"
            },
            {
                "country_ar": "إسبانيا",
                "phone_code": "+34"
            },
            {
                "country_ar": "سانت هيلانة",
                "phone_code": "+290"
            },
            {
                "country_ar": "سورينام",
                "phone_code": "+597"
            },
            {
                "country_ar": "سفالبارد ويان ماين",
                "phone_code": "+47"
            },
            {
                "country_ar": "السويد",
                "phone_code": "+46"
            },
            {
                "country_ar": "سويسرا",
                "phone_code": "+41"
            },
            {
                "country_ar": "تايوان",
                "phone_code": "+886"
            },
            {
                "country_ar": "طاجيكستان",
                "phone_code": "+992"
            },
            {
                "country_ar": "تنزانيا",
                "phone_code": "+255"
            },
            {
                "country_ar": "تايلندا",
                "phone_code": "+66"
            },
            {
                "country_ar": "تيمور الشرقية",
                "phone_code": "+670"
            },
            {
                "country_ar": "توغو",
                "phone_code": "+228"
            },
            {
                "country_ar": "توكيلاو",
                "phone_code": "+690"
            },
            {
                "country_ar": "تونغا",
                "phone_code": "+676"
            },
            {
                "country_ar": "ترينيداد وتوباغو",
                "phone_code": "+868"
            },
            {
                "country_ar": "تركيا",
                "phone_code": "+90"
            },
            {
                "country_ar": "تركمانستان",
                "phone_code": "+993"
            },
            {
                "country_ar": "جزر توركس وكايكوس",
                "phone_code": "+1"
            },
            {
                "country_ar": "توفالو",
                "phone_code": "+688"
            },
            {
                "country_ar": "أوغندا",
                "phone_code": "+256"
            },
            {
                "country_ar": "أوكرانيا",
                "phone_code": "+380"
            },
            {
                "country_ar": "المملكة المتحدة",
                "phone_code": "+44"
            },
            {
                "country_ar": "الولايات المتحدة",
                "phone_code": "+1"
            },
            {
                "country_ar": "أورغواي",
                "phone_code": "+598"
            },
            {
                "country_ar": "أوزباكستان",
                "phone_code": "+998"
            },
            {
                "country_ar": "فانواتو",
                "phone_code": "+678"
            },
            {
                "country_ar": "فنزويلا",
                "phone_code": "+58"
            },
            {
                "country_ar": "فيتنام",
                "phone_code": "+84"
            },
            {
                "country_ar": "فنزويلا",
                "phone_code": "+379"
            },
            {
                "country_ar": "الصحراء الغربية",
                "phone_code": "+212"
            },
            {
                "country_ar": "زامبيا",
                "phone_code": "+260"
            },
            {
                "country_ar": "زمبابوي",
                "phone_code": "+263"
            }
        ]
    }